import { useEffect, useRef } from "react";
import { useDataAuth } from './useDataAuth';
import { getContacts, getInitialMessages } from "../services/whatsApp.service";
import { transformMessages } from "../utils/whatsApp/transformMessages";

const urlWebSocketWhatsApp = process.env.REACT_APP_AWS_WEB_SOCKET_WHATS_APP;

export function useWebhookEvents(viewAllAccess, chatSelected, setMessages, setContacts) {
    const [{ userSession }] = useDataAuth();
    const pingIntervalRef = useRef(null);
    const wsRef = useRef(null);
    const defaultPingInterval = 9 * 60 * 1000;

    useEffect(() => {
        if (!userSession?.token) return;
        const ws = new WebSocket(urlWebSocketWhatsApp);
        wsRef.current = ws;
        const startPingInterval = () => {
            if (pingIntervalRef.current) clearInterval(pingIntervalRef.current);
            pingIntervalRef.current = setInterval(() => {
                if (ws.readyState === WebSocket.OPEN) {
                    ws.send(JSON.stringify({ action: "ping", message: "" }));
                }
            }, defaultPingInterval);
        };

        ws.onopen = () => {
            startPingInterval();
        };

        ws.onmessage = async (event) => {
            try {
                const data = JSON.parse(event.data);
                startPingInterval();
                if (data) {
                    await fetchContacts();
                    if (chatSelected) {
                        await fetchMessages();
                    }
                }
            } catch (err) {
                console.error("Error parsing WebSocket message", err);
            }
        };

        ws.onerror = (err) => {
            console.error("❌ WebSocket error", err);
        };

        ws.onclose = () => {
            if (pingIntervalRef.current) clearInterval(pingIntervalRef.current);
        };

        const fetchMessages = async () => {
            try {
                const response = await getInitialMessages(
                    userSession.token,
                    chatSelected.id_marketing_whatsapp
                );
                if (response?.data) {
                    transformMessages(response.data, setMessages);
                }
            } catch (error) {
                console.error("Error fetching updated messages", error);
            }
        };

        const fetchContacts = async () => {
            try {
                const responseContacts = await getContacts(viewAllAccess?'NOT_BY_USER':"BY_USER", userSession.token);
                if (responseContacts?.data) {
                    setContacts(responseContacts.data);
                }
            } catch (error) {
                console.error('Error fetching contacts:', error);
            }
        };

        return () => {
            console.log("Cleaning up WebSocket...");
            ws.close();
            if (pingIntervalRef.current) clearInterval(pingIntervalRef.current);
        };
    }, [userSession?.token, setMessages, setContacts]);
}
